import actions from "./actions";

const initState = {
  rewards: [],
  totalCount: 0,
  loading: false,
  status: "",
  error: "",
  schools: [],
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.SET_REWARDS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };

    case actions.SET_REWARDS_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case actions.UPLOAD_REWARDS_FILE:
      return {
        ...state,
        status: "",
      };

    case actions.UPLOAD_REWARDS_FILE_SUCCESS:
      return {
        ...state,
        status: action.status,
      };

    case actions.RESET:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case actions.REQUEST_REWARDS_SUCCESS:
      return {
        ...state,
        rewards: action.rewards?.requests || [],
        totalCount: action.rewards?.pagination?.totalCount || 0,
      };

    case actions.FETCH_SCHOOLS_SUCCESS:
      return {
        ...state,
        schools: action.schools,
        loading: false,
      };

    default:
      return state;
  }
}
